export const roleTypes = {
  FLEET_MANAGER: ['USER', 'FLEET_MANAGER'],
  INSTRUCTOR: ['USER', 'REVIEWER', 'INSTRUCTOR'],
  PC_OPERATOR: ['USER', 'REVIEWER', 'PC_OPERATOR'],
  PSYCHOLOGIST: ['USER', 'REVIEWER', 'PSYCHOLOGIST'],
  ADMIN: ['USER', 'REVIEWER', 'INSTRUCTOR', 'PC_OPERATOR', 'PSYCHOLOGIST', 'FLEET_MANAGER', 'ADMIN'],
  SUPERVISOR: ['USER', 'REVIEWER', 'INSTRUCTOR', 'PC_OPERATOR', 'PSYCHOLOGIST', 'FLEET_MANAGER', 'ADMIN', 'SUPERVISOR'],
}

export const roles = {
  USER: 'USER',
  REVIEWER: 'REVIEWER',
  INSTRUCTOR: 'INSTRUCTOR',
  PC_OPERATOR: 'PC_OPERATOR',
  PSYCHOLOGIST: 'PSYCHOLOGIST',
  FLEET_MANAGER: 'FLEET_MANAGER',
  ADMIN: 'ADMIN',
  SUPERVISOR: 'SUPERVISOR',
}

export const assignableRoles = {
  INSTRUCTOR: 'INSTRUKTOR',
  PC_OPERATOR: 'PC ASISTENT',
  PSYCHOLOGIST: 'PSYCHOLOG',
  FLEET_MANAGER: 'FLEET MANAGER',
  ADMIN: 'ORGANIZAČNÍ ODD.',
  SUPERVISOR: 'SUPERVISOR',
}

export const courseTypes = {
  ABJ: 'ABJ',
  DDC: 'DDC',
  ECO: 'ECO',
  BC_BASIC: 'BC_BASIC',
  B_CADY: 'B_CADY',
  AUDIT: 'AUDIT',
  OTHER: 'OTHER',
}

export const vehicleTypes = {
  M1: 'M1',
  M2: 'M2',
  M3: 'M3',
  N1: 'N1',
  N2: 'N2',
  N3: 'N3',
}

export const DBCourseTypes = {
  ABJ: 'ABJ',
  DDC: 'DDC',
  ECO: 'ECO',
  BC_BASIC: 'BC_BASIC',
  B_CADY: 'B_CADY',
  AUDIT: 'AUDIT',
  OTHER: 'OTHER',
}

export const DBVehicleTypes = {
  M1: 'M1',
  M2: 'M2',
  M3: 'M3',
  N1: 'N1',
  N2: 'N2',
  N3: 'N3',
  N: 'N',
}

export const courseTypesFormated = {
  ABJ: {
    abbreviation: 'ABJ',
    name: 'Aktivní bezpečná jízda',
  },
  DDC: {
    abbreviation: 'DDC',
    name: 'Defenzivní jízda',
  },
  ECO: {
    abbreviation: 'ECO',
    name: 'Ekonomická a ekologická jízda',
  },
  BC_BASIC: {
    abbreviation: 'BlueCare basic',
    name: 'BlueCare basic',
  },
  B_CADY: {
    abbreviation: 'BlueCare advanced',
    name: 'BlueCare advanced',
  },
  AUDIT: {
    abbreviation: 'Audit',
    name: 'Audit',
  },
  OTHER: {
    abbreviation: 'Jiný',
    name: 'Jiný',
  },
}

export const resultTypes = {
  PASSED: 'Prospěl',
  FAILED: 'Neprospěl',
  UNDECIDED: 'Nehodnocen',
}

export const mistakeTypes = {
  TRAFFIC_RULES: 'TRAFFIC_RULES',
  DRIVING_TECHNIQUE: 'DRIVING_TECHNIQUE',
  DEFENSIVE_DRIVING: 'DEFENSIVE_DRIVING',
  DRIVING_ECONOMY: 'DRIVING_ECONOMY',
}

export const mistakeTypesFormated = {
  TRAFFIC_RULES: 'Pravidla provozu',
  DRIVING_TECHNIQUE: 'Technika jízdy',
  DEFENSIVE_DRIVING: 'Defenzivní jízda',
  DRIVING_ECONOMY: 'Ekonomika jízdy',
}

export const genders = {
  MALE: 'Muž',
  FEMALE: 'Žena',
}

export default {
  roleTypes,
  roles,
  courseTypes,
  assignableRoles,
  resultTypes,
  mistakeTypes,
  mistakeTypesFormated,
  genders,
  courseTypesFormated,
  vehicleTypes,
}



// WEBPACK FOOTER //
// ./src/common/config.js